/**
 * Coups de pouce — Attendu 1069 « Reconnaitre un patron d'un cube ».
 *
 * patron_qcm_unique + patron_tableau_vf + patron_raison_qcm_unique +
 * bande_qcm_unique : entrée PARTAGÉE — compter les six carrés, chercher la
 * bande de 4 qui fait le tour ; pour compléter, placer le dernier carré de
 * l'autre côté (la ligne « un carré de chaque côté » a été retirée de la règle
 * à la demande du prof, 2026-09-05 ; l'exemple la montre). L'exemple (revue 2026-09-05) : la
 * bande avec un carré au-dessus, le sixième en dessous (patron) ou au-dessus
 * (deux carrés se superposent). SVG piloté par les flèches de la sheet.
 *
 * Sans coup de pouce (pur rappel) : rappel_qcm_unique, vf_tableau_vf.
 */

const C = 22;   // côté d'un carré
const CASE = (x, y, fill = '#bfdbfe') => `<rect x="${x}" y="${y}" width="${C}" height="${C}" fill="${fill}" stroke="#1e293b" stroke-width="1.4"/>`;
const CASE_POINT = (x, y, col) => `<rect x="${x + 1}" y="${y + 1}" width="${C - 2}" height="${C - 2}" fill="${col}" fill-opacity="0.25" stroke="${col}" stroke-width="1.6" stroke-dasharray="4 3"/>`;

const SVG_PATRON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Reconnaître un patron du cube, en 3 étapes à faire défiler avec les flèches. Une bande de quatre carrés alignés, avec un cinquième carré au-dessus du deuxième. Étape 2 : un sixième carré placé en dessous de la bande, sous le troisième carré ; un carré au-dessus et un carré en dessous, le dessus et le dessous du cube sont fermés, c'est un patron. Étape 3 : si le sixième carré est placé au-dessus, à côté du cinquième, deux carrés du même côté se superposent en pliant et le dessous reste ouvert, ce n'est pas un patron. Une bande de 4, et un carré de chaque côté">
  <style>
    @keyframes cp1069-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1069-pop { opacity: 0; animation: cp1069-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">La bande de 4 fait le tour du cube</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Un carré de chaque côté : c'est un patron</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Deux carrés du même côté : pas un patron</text>

  <!-- ── La bande et le cinquième carré (étape 1) ───────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    ${CASE(40, 120, '#bbf7d0')}${CASE(62, 120, '#bbf7d0')}${CASE(84, 120, '#bbf7d0')}${CASE(106, 120, '#bbf7d0')}
    ${CASE(62, 98)}
    <text x="84" y="185" font-size="11" font-weight="600" fill="#0f5c44" text-anchor="middle">4 carrés alignés : les faces latérales</text>
    <text x="84" y="199" font-size="11" font-weight="600" fill="#475569" text-anchor="middle">le 5e ferme le dessus</text>
  </g>

  <!-- ── Le bon côté (étape 2) ──────────────────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1069-pop">
      ${CASE_POINT(84, 142, '#1D9E75')}
      <text x="95" y="158" font-size="13" font-weight="800" fill="#1D9E75" text-anchor="middle">✓</text>
      <text x="186" y="60" font-size="11.5" font-weight="700" fill="#1D9E75">Un carré au-dessus,</text>
      <text x="186" y="75" font-size="11.5" font-weight="700" fill="#1D9E75">un carré en dessous :</text>
      <text x="186" y="90" font-size="11.5" font-weight="700" fill="#1D9E75">le dessus et le dessous</text>
      <text x="186" y="105" font-size="11.5" font-weight="700" fill="#1D9E75">du cube sont fermés.</text>
      <text x="186" y="125" font-size="11.5" font-weight="800" fill="#1D9E75">C'est un patron ✓</text>
      <text x="186" y="140" font-size="10" font-weight="600" fill="#475569">(pas forcément sous le même carré)</text>
    </g>
  </g>

  <!-- ── Le mauvais côté (étape 3) ──────────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1069-pop">
      ${CASE_POINT(84, 98, '#B45309')}
      <text x="95" y="114" font-size="13" font-weight="800" fill="#B45309" text-anchor="middle">✗</text>
      <text x="186" y="165" font-size="11.5" font-weight="700" fill="#B45309">Deux carrés du même côté :</text>
      <text x="186" y="180" font-size="11.5" font-weight="700" fill="#B45309">en pliant, ils se superposent</text>
      <text x="186" y="195" font-size="11.5" font-weight="700" fill="#B45309">et le dessous reste ouvert.</text>
      <text x="186" y="215" font-size="11.5" font-weight="800" fill="#B45309">Ce n'est pas un patron ✗</text>
      <text x="180" y="246" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Une bande de 4, et un carré de chaque côté.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_PATRON = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                '**Compte d\'abord** : un patron du cube a exactement 6 carrés. 5, il manque une face ; 7, un carré se superposerait.',
                '**Cherche la bande** : dans presque tous les patrons, 4 carrés alignés font le tour du cube (ses quatre faces latérales). Jamais 5 ou 6 alignés : le cinquième retomberait sur le premier.',
                "**Pour compléter** : repère la bande de 4, regarde de quel côté est le carré déjà posé, et place le dernier **de l'autre côté**, sur n'importe lequel des quatre carrés de la bande.",
            ],
        },
        { titre: 'Un exemple', svg: SVG_PATRON },
    ],
};

const CP_1069 = {
    patron_qcm_unique: AIDE_PATRON,
    patron_tableau_vf: AIDE_PATRON,
    patron_raison_qcm_unique: AIDE_PATRON,
    bande_qcm_unique: AIDE_PATRON,
};

export default CP_1069;
